import React from 'react';

import './Expired.component.css';

export default class Expired extends React.Component {
    render() {
        return (
            <div className="expired-container">
                Expired link
            </div>
        );
    }
}